import { apiFetch } from "./client.ts";

export interface EventRecord {
  id: string;
  eventName: string;
  eventVersion: number;
  correlationId: string;
  workflowId: string | null;
  causationId: string | null;
  sourceAgent: string;
  priority: string;
  payload: Record<string, unknown>;
  createdAt: string;
}

export async function listEvents(
  token: string,
  params: { correlationId?: string; workflowId?: string; eventName?: string; limit?: number } = {},
): Promise<EventRecord[]> {
  const qs = new URLSearchParams();
  if (params.correlationId) qs.set("correlationId", params.correlationId);
  if (params.workflowId) qs.set("workflowId", params.workflowId);
  if (params.eventName) qs.set("eventName", params.eventName);
  if (params.limit) qs.set("limit", String(params.limit));
  const query = qs.toString() ? `?${qs.toString()}` : "";
  return apiFetch<EventRecord[]>(`/api/v1/events${query}`, { token });
}

export async function getEvent(token: string, id: string): Promise<EventRecord> {
  return apiFetch<EventRecord>(`/api/v1/events/${id}`, { token });
}
